// restorationType images 
import amalgamImg from '../../../Assets/images/tooth_surfaces/restoration/Amalgam.svg'
import ceramicImg from '../../../Assets/images/tooth_surfaces/restoration/ceramic.svg'
import compositeImg from '../../../Assets/images/tooth_surfaces/restoration/composite.svg'
import goldImg from '../../../Assets/images/tooth_surfaces/restoration/Gold 1.png'
import metalImg from '../../../Assets/images/tooth_surfaces/restoration/Metal.svg'
import porcelainImg from '../../../Assets/images/tooth_surfaces/restoration/Procelain.svg'
import resinImg from '../../../Assets/images/tooth_surfaces/restoration/Resin.svg'
import sealantImg from '../../../Assets/images/tooth_surfaces/restoration/Sealent.svg'
import unknownImg from '../../../Assets/images/tooth_surfaces/restoration/nknown.svg'

// impacted type images 
import impactedDeciduousImg from '../../../Assets/images/tooth_surfaces/impacted/impacted_deciduous.svg'
import impactedPermanentImg from '../../../Assets/images/tooth_surfaces/impacted/impacted_permanent.svg'

// root canal type images 
import root_canalUnknownImg from '../../../Assets/images/tooth_surfaces/root_canal/Other.svg'
import root_canalOtherImg from '../../../Assets/images/tooth_surfaces/root_canal/Unknown.svg'


// implant type images 
import blade_implantImg from '../../../Assets/images/tooth_surfaces/implant/blade_implant.svg'
import cylinder_implantImg from '../../../Assets/images/tooth_surfaces/implant/cylinder_implant.svg'
import perio_implantImg from '../../../Assets/images/tooth_surfaces/implant/perio_implant.svg'
import post_implantImg from '../../../Assets/images/tooth_surfaces/implant/post_implant.svg'

// watch arrow
import arrow from "../../../Assets/images/Arrowpng.png"

// conditions
import Trauma from "../../../Assets/SVG_Conditions/Trauma.svg"
import SquareMiddle from "../../../Assets/SVG_Conditions/SquareMiddle.svg"
import SquareMesial from "../../../Assets/SVG_Conditions/SquareMesial.svg"
import SquareDistal from "../../../Assets/SVG_Conditions/SquareDistal.svg"
import Splinted from "../../../Assets/SVG_Conditions/Splinted.svg"
import Spacer from "../../../Assets/SVG_Conditions/Spacer.svg"
import Pins from "../../../Assets/SVG_Conditions/Pins.svg"
import PartiallyErupted from "../../../Assets/SVG_Conditions/PartiallyErupted.svg"
import OpenMarginMesial from "../../../Assets/SVG_Conditions/OpenMarginMesial.svg"
import OpenMarginDistalNEW from "../../../Assets/SVG_Conditions/OpenMarginDistalNEW.svg"
import OpenContactMesial from "../../../Assets/SVG_Conditions/OpenContactMesial.svg"
import OpenContactDistal from "../../../Assets/SVG_Conditions/OpenContactDistal.svg"
import LooseTooth from "../../../Assets/SVG_Conditions/LooseTooth.svg"
import Intrusion from "../../../Assets/SVG_Conditions/Intrusion.svg"
import ImpactedDistal from "../../../Assets/SVG_Conditions/ImpactedDistal.svg"
import ImactedMesial from "../../../Assets/SVG_Conditions/ImactedMesial.svg"
import Hypoplasia from "../../../Assets/SVG_Conditions/Hypoplasia.svg"
import Hypersensitivity from "../../../Assets/SVG_Conditions/Hypersensitivity.svg"
import Gemination from "../../../Assets/SVG_Conditions/Gemination.svg"
import Fusion from "../../../Assets/SVG_Conditions/Fusion.svg"
import EctopicEruption from "../../../Assets/SVG_Conditions/EctopicEruption.svg"
import DriftMesial from "../../../Assets/SVG_Conditions/DriftMesial.svg"
import DriftDistal from "../../../Assets/SVG_Conditions/DriftDistal.svg"
import Discoloration from "../../../Assets/SVG_Conditions/Discoloration.svg"
import CongenitallyMissing from "../../../Assets/SVG_Conditions/CongenitallyMissing.svg"
import Concussion from "../../../Assets/SVG_Conditions/Concussion.svg"
import Braces from "../../../Assets/SVG_Conditions/Braces.svg"
import Avulsion from "../../../Assets/SVG_Conditions/Avulsion.svg"
import Ankylosis from "../../../Assets/SVG_Conditions/Ankylosis.svg"
import Abfraction from "../../../Assets/SVG_Conditions/Abfraction.svg"
// bridge type images 
import bridge_ceramic from '../../../Assets/images/tooth_surfaces/crown/ceramic.png'
import bridge_composite from '../../../Assets/images/tooth_surfaces/crown/composite.png'
import bridge_gold from '../../../Assets/images/tooth_surfaces/crown/gold.png'
import bridge_metal from '../../../Assets/images/tooth_surfaces/crown/metal.png'
import bridge_porcelain from '../../../Assets/images/tooth_surfaces/crown/porcelain.png'
import bridge_resin from '../../../Assets/images/tooth_surfaces/crown/resin.png'
import bridge_titanium from '../../../Assets/images/tooth_surfaces/crown/titanium.png'
import bridge_unknown from '../../../Assets/images/tooth_surfaces/crown/unknown.png'
import bridge_resinOnMetal from '../../../Assets/images/tooth_surfaces/crown/resinOnMetal.png'
import bridge_resinOnHighNobelMetal from '../../../Assets/images/tooth_surfaces/crown/resinOnHighNobelMetal.png'

import partialDentureImg from '../../../Assets/images/tooth_surfaces/denture/partial.svg'


export const materialTypes = [
  { title: 'Amalgam', value: 'amalgam', img: amalgamImg },
  { title: 'Ceramic', value: 'ceramic', img: ceramicImg },
  { title: 'Composite', value: 'composite', img: compositeImg},
  { title: 'Gold', value: 'gold', img: goldImg },
  { title: 'Metal', value: 'metal', img: metalImg },
  { title: 'Resin', value: 'resin', img: resinImg  },
  { title: 'Sealant', value: 'sealant', img: sealantImg },
  { title: 'Unknown', value: 'unknown', img: unknownImg },
  { title: 'Plastic', value: 'plastic', img: metalImg },
  { title: 'Porcelain', value: 'porcelain', img: porcelainImg },
  { title: 'Titanium', value: 'titanium',  img: amalgamImg },
  { title: 'Deciduos', value: 'deciduos', img: impactedDeciduousImg },
  { title: 'Nylon', value: 'nylon' },
  { title: 'Other', value: 'other', img: root_canalOtherImg },
  { title: 'Veneer', value: 'veneer' },
  { title: 'Arestin', value: 'arestin' },
  { title: 'Acrylic', value: 'acrylic' },
  { title: 'Permanent', value: 'permanent', img: impactedPermanentImg },
  { title: 'Implant Post', value: 'implantPost', img: perio_implantImg },
  { title: 'Gutta-Percha', value: 'guttaPercha', img: root_canalOtherImg },
  { title: 'Implant Blade', value: 'implantBlade', img: blade_implantImg },
  { title: 'Resin On Metal', value: 'resinOnMetal', img: goldImg },
  { title: 'Supernumerary', value: 'supernumerary', img: impactedPermanentImg },
  { title: 'Stainless Steel', value: 'stainlessSteel', img: compositeImg },
  { title: 'High Nobel Metal', value: 'highNobelMetal', img: ceramicImg },
  { title: 'Implant Cylinder', value: 'implantCylinder', img: cylinder_implantImg },
  { title: 'Periosteal Implant', value: 'periostealImplant', img: post_implantImg },
  { title: 'Unerupted Deciduous', value: 'uneruptedDeciduous' },
  { title: 'Unerupted Permanent', value: 'uneruptedPermanent' },
  { title: 'Porcelain Fused To Gold', value: 'porcelainFusedToGold', img: goldImg },
  { title: 'Porcelain Fused To Metal', value: 'porcelainFusedToMetal', img: metalImg },
  { title: 'Resin On High Nobel Metal', value: 'resinOnHighNobelMetal', img: goldImg },
  { title: 'Porcelain Fused To Titanium', value: 'porcelainFusedToTitanium', img: resinImg },
  { title: 'Porcelain Fused To High Nobel Metal', value: 'porcelainFusedToHighNobelMetal', img: porcelainImg },
]

export const handleImagesOnCondition = (data, category)=> {
// console.log(category)
if(category == 'RESTORATIVE' || category == "PREVENTIVE"){
  if (data?.name == "Amalgam") return amalgamImg
  if (data?.name == "Ceramic") return ceramicImg
  if (data?.name == "Composite") return compositeImg
  if (data?.name == "Gold") return goldImg
  if (data?.name == "Metal") return metalImg
  if (data?.name == "Porcelain") return porcelainImg
  if (data?.name == "Resin") return resinImg
  if (data?.name == "Sealant") return sealantImg
  if (data?.name == "Unknown") return unknownImg
}

if(category == 'ADJUNCTIVE GENERAL SERVICES'){
if (data?.name == "Deciduos") return impactedDeciduousImg
if (data?.name == "Permanent") return impactedPermanentImg
}
if(category == 'ENDODONTICS'){
if (data?.name == "Deciduos") return impactedDeciduousImg
if (data?.name == "Supernumerary") return impactedPermanentImg
}
if(category == 'FIXED PROSTHODONTICS'){
if (data?.name == "Ceramic") return ceramicImg
if (data?.name == "Composite") return compositeImg
if (data?.name == "Gold") return goldImg
if (data?.name == "High Nobel Metal") return ceramicImg
if (data?.name == "Metal") return metalImg
if (data?.name == "Plastic") return metalImg
if (data?.name == "Porcelain") return porcelainImg
if (data?.name == "Porcelain Fused To Gold") return goldImg
if (data?.name == "Porcelain Fused To High Nobel Metal") return porcelainImg
if (data?.name == "Porcelain Fused To Metal") return metalImg
if (data?.name == "Porcelain Fused To Titanium") return resinImg
if (data?.name == "Resin") return resinImg
if (data?.name == "Resin On High Nobel Metal") return goldImg
if (data?.name == "Resin On Metal") return goldImg
if (data?.name == "Stainless Steel") return compositeImg
if (data?.name == "Titanium") return amalgamImg
if (data?.name == "Unknown") return unknownImg


}

if(category == 'MAXILLOFACIAL PROSTHETICS'){
if (data?.name == "Ceramic") return bridge_ceramic
if (data?.name == "Composite") return bridge_composite
if (data?.name == "Gold") return bridge_gold
if (data?.name == "High Nobel Metal") return bridge_ceramic
if (data?.name == "Metal") return bridge_metal
if (data?.name == "Porcelain") return bridge_porcelain
if (data?.name == "Porcelain Fused To Gold") return bridge_gold
if (data?.name == "Porcelain Fused To High Nobel Metal") return bridge_porcelain
if (data?.name == "Porcelain Fused To Metal") return bridge_metal
if (data?.name == "Porcelain Fused To Titanium") return bridge_titanium
if (data?.name == "Resin") return bridge_resin
if (data?.name == "Resin On High Nobel Metal") return bridge_resinOnHighNobelMetal
if (data?.name == "Resin On Metal") return bridge_resinOnMetal
if (data?.name == "Titanium") return bridge_titanium
if (data?.name == "Unknown") return bridge_unknown
}
if(category == 'REMOVABLE PROSTHODONTICS'){
if (data?.name == "Gutta-Percha") return root_canalOtherImg
if (data?.name == "Other") return root_canalOtherImg
if (data?.name == "Unknown") return root_canalUnknownImg
}
if(category == 'DENTURE')  if (data?.name == "Partial") return partialDentureImg

if(category == 'MISSING'){
if (data?.name == "Deciduos") return ''
if (data?.name == "Unerupted Deciduous") return ''
if (data?.name == "Permanent") return ''
if (data?.name == "Unerupted Permanent") return ''
}

if(category == 'UNMISSING'){
if (data?.name == "Acrylic") return ''
if (data?.name == "Nylon") return ''
if (data?.name == "Porcelain") return ''
if (data?.name == "Resin") return ''
if (data?.name == "Metal") return ''
}
  return ''
}

export const restorationTypeArry = [
  { img: amalgamImg, title: 'Amalgam' },
  { img: ceramicImg, title: 'Ceramic' },
  { img: compositeImg, title: 'Composite' },
  { img: goldImg, title: 'Gold' },
  { img: metalImg, title: 'Metal' },
  { img: porcelainImg, title: 'Porcelain' },
  { img: resinImg, title: 'Resin' },
  { img: sealantImg, title: 'Sealant' },
  { img: unknownImg, title: 'Unknown' },
]

export const crownTypeArry = [
  { img: ceramicImg, title: 'Ceramic' },
  { img: compositeImg, title: 'Composite' },
  { img: goldImg, title: 'Gold' },
  { img: ceramicImg, title: 'High Nobel Metal' },
  { img: metalImg, title: 'Metal' },
  { img: metalImg, title: 'Plastic' },
  { img: porcelainImg, title: 'Porcelain' },
  { img: goldImg, title: 'Porcelain Fused To Gold' },
  { img: porcelainImg, title: 'Porcelain Fused To High Nobel Metal' },
  { img: metalImg, title: 'Porcelain Fused To Metal' },
  { img: resinImg, title: 'Porcelain Fused To Titanium' },
  { img: resinImg, title: 'Resin' },
  { img: goldImg, title: 'Resin On High Nobel Metal' },
  { img: goldImg, title: 'Resin On Metal' },
  { img: compositeImg, title: 'Stainless Steel' },
  { img: amalgamImg, title: 'Titanium' },
  { img: unknownImg, title: 'Unknown' },
]

export const bridgeTypeArry = [
  { img: bridge_ceramic, title: 'Ceramic' },
  { img: bridge_composite, title: 'Composite' },
  { img: bridge_gold, title: 'Gold' },
  { img: bridge_ceramic, title: 'High Nobel Metal' },
  { img: bridge_metal, title: 'Metal' },
  { img: bridge_porcelain, title: 'Porcelain' },
  { img: bridge_gold, title: 'Porcelain Fused To Gold' },
  { img: bridge_porcelain, title: 'Porcelain Fused To High Nobel Metal' },
  { img: bridge_metal, title: 'Porcelain Fused To Metal' },
  { img: bridge_titanium, title: 'Porcelain Fused To Titanium' },
  { img: bridge_resin, title: 'Resin' },
  { img: bridge_resinOnHighNobelMetal, title: 'Resin On High Nobel Metal' },
  { img: bridge_resinOnMetal, title: 'Resin On Metal' },
  { img: bridge_titanium, title: 'Titanium' },
  { img: bridge_unknown, title: 'Unknown' },
]


export const missingTypeArry = [
  { title: 'Deciduos' },
  { title: 'Unerupted Deciduous' },
  { title: 'Permanent' },
  { title: 'Unerupted Permanent' }
]

export const unMissingTypeArry = [
  { title: 'Acrylic' },
  { title: 'Nylon' },
  { title: 'Porcelain' },
  { title: 'Resin' },
  { title: 'Metal' }
]

export const impactedTypeArry = [
  { img: impactedDeciduousImg, title: 'Deciduos' },
  { img: impactedPermanentImg, title: 'Permanent' }
]

export const eruptedTypeArry = [
  { img: impactedDeciduousImg, title: 'Deciduos' },
  { img: impactedPermanentImg, title: 'Supernumerary' }
]

export const rootCanalTypeArry = [
  { img: root_canalOtherImg, title: 'Gutta-Percha' },
  { img: root_canalOtherImg, title: 'Other' },
  { img: root_canalUnknownImg, title: 'Unknown' },
]

export const implantTypeArry = [
  { img: blade_implantImg, title: 'Implant Blade' },
  { img: cylinder_implantImg, title: 'Implant Cylinder' },
  { img: perio_implantImg, title: 'Implant Post' },
  { img: post_implantImg, title: 'Periosteal Implant' },
]

export const implantMaterialTypes = [
  { value: 'amalgam', label: 'Amalgam' },
  { value: 'arestin', label: 'Arestin' },
  { value: 'ceramic', label: 'Ceramic' },
  { value: 'composite', label: 'Composite' },
  { value: 'gold', label: 'Gold' },
  { value: 'guttaPercha', label: 'Gutta-Percha' },
  { value: 'highNobelMetal', label: 'High Nobel Metal' },
  { value: 'metal', label: 'Metal' },
  { value: 'other', label: 'Other' },
  { value: 'plastic', label: 'Plastic' },
  { value: 'porcelain', label: 'Porcelain' },
  { value: 'porcelainFusedToGold', label: 'Porcelain Fused To Gold' },
  { value: 'porcelainFusedToHighNobelMetal', label: 'Porcelain Fused To High Nobel Metal' },
  { value: 'porcelainFusedToMetal', label: 'Porcelain Fused To Metal' },
  { value: 'porcelainFusedToTitanium', label: 'Porcelain Fused To Titanium' },
  { value: 'resin', label: 'Resin' },
  { value: 'resinOnHighNobelMetal', label: 'Resin On High Nobel Metal' },
  { value: 'resinOnMetal', label: 'Resin On Metal' },
  { value: 'sealant', label: 'Sealant' },
  { value: 'stainlessSteel', label: 'Stainless Steel' },
  { value: 'titanium', label: 'Titanium' },
  { value: 'unknown', label: 'Unknown' },
  { value: 'veneer', label: 'Veneer' },
]

// Watch data
const treatmentPlanId = Math.floor(Math.random() * 9999) + 1;

export const watchArrowArray = [
  { title: "North-East", position_X: 35, position_Y: 0, img: arrow, degrees: "310deg", type: "ORTHODONTICS", watchNotes: null, treatmentPlanId: treatmentPlanId },
  { title: "North-West", position_X: 0, position_Y: 0, img: arrow, degrees: "230deg", type: "ORTHODONTICS", watchNotes: null, treatmentPlanId: treatmentPlanId + 1 },
  { title: "South-East", position_X: 0, position_Y: 0, img: arrow, degrees: "40deg", type: "ORTHODONTICS", watchNotes: null, treatmentPlanId: treatmentPlanId + 2 },
  { title: "South-West", position_X: 0, position_Y: 0, img: arrow, degrees: "130deg", type: "ORTHODONTICS", watchNotes: null, treatmentPlanId: treatmentPlanId + 3 },
]

// PERIODONTICS data
export const conditionsArray = [
  { title: "Abfraction", position_X: 0, position_Y: 0, img: Abfraction, type: "CONDITION" },
  { title: "Ankylosis", position_X: 0, position_Y: 0, img: Ankylosis, type: "CONDITION" },
  { title: "Avulsion", position_X: 0, position_Y: 0, img: Avulsion, type: "CONDITION" },
  { title: "Braces", position_X: 0, position_Y: 0, img: Braces, type: "CONDITION" },
  { title: "Calculus", position_X: 0, position_Y: 0, img: Hypersensitivity, type: "CONDITION" },
  { title: "Concussion", position_X: 0, position_Y: 0, img: Concussion, type: "CONDITION" },
  { title: "Congenitally Missing", position_X: 0, position_Y: 0, img: CongenitallyMissing, type: "CONDITION" },
  { title: "Discoloration", position_X: 0, position_Y: 0, img: Discoloration, type: "CONDITION" },
  { title: "Drift Distal", position_X: 0, position_Y: 0, img: DriftDistal, type: "CONDITION" },
  { title: "Drift Mesial", position_X: 0, position_Y: 0, img: DriftMesial, type: "CONDITION" },
  { title: "Ectopic Eruption", position_X: 0, position_Y: 0, img: EctopicEruption, type: "CONDITION" },
  { title: "Fused / Germinated Tooth", position_X: 0, position_Y: 0, img: Hypersensitivity, type: "CONDITION" },
  { title: "Fusion", position_X: 0, position_Y: 0, img: Fusion, type: "CONDITION" },
  { title: "Gemination", position_X: 0, position_Y: 0, img: Gemination, type: "CONDITION" },
  { title: "Hypersensitivity", position_X: 0, position_Y: 0, img: Hypersensitivity, type: "CONDITION" },
  { title: "Hypoplasia", position_X: 0, position_Y: 0, img: Hypoplasia, type: "CONDITION" },
  { title: "Impacted Distal", position_X: 0, position_Y: 0, img: ImpactedDistal, type: "CONDITION" },
  { title: "Impacted Mesial", position_X: 0, position_Y: 0, img: ImactedMesial, type: "CONDITION" },
  { title: "Intrusion", position_X: 0, position_Y: 0, img: Intrusion, type: "CONDITION" },
  { title: "Laceration", position_X: 0, position_Y: 0, img: Hypersensitivity, type: "CONDITION" },
  { title: "Loose Tooth", position_X: 0, position_Y: 0, img: LooseTooth, type: "CONDITION" },
  { title: "Open Contact Distal", position_X: 0, position_Y: 0, img: OpenContactDistal, type: "CONDITION" },
  { title: "Open Contact Mesial", position_X: 0, position_Y: 0, img: OpenContactMesial, type: "CONDITION" },
  { title: "Open Margin Distal", position_X: 0, position_Y: 0, img: OpenMarginDistalNEW, type: "CONDITION" },
  { title: "Open Margin Mesial", position_X: 0, position_Y: 0, img: OpenMarginMesial, type: "CONDITION" },
  { title: "Partially Erupted", position_X: 0, position_Y: 0, img: PartiallyErupted, type: "CONDITION" },
  { title: "Peg Lateral", position_X: 0, position_Y: 0, img: Hypersensitivity, type: "CONDITION" },
  { title: "Pins", position_X: 0, position_Y: 0, img: Pins, type: "CONDITION" },
  { title: "Poor Marg Integrity", position_X: 0, position_Y: 0, img: Hypersensitivity, type: "CONDITION" },
  { title: "Recession", position_X: 0, position_Y: 0, img: Hypersensitivity, type: "CONDITION" },
  { title: "Spacer", position_X: 0, position_Y: 0, img: Spacer, type: "CONDITION" },
  { title: "Splinted", position_X: 0, position_Y: 0, img: Splinted, type: "CONDITION" },
  { title: "Square Distal", position_X: 0, position_Y: 0, img: SquareDistal, type: "CONDITION" },
  { title: "Square Mesial", position_X: 0, position_Y: 0, img: SquareMesial, type: "CONDITION" },
  { title: "Square Middle", position_X: 0, position_Y: 0, img: SquareMiddle, type: "CONDITION" },
  { title: "Trauma", position_X: 0, position_Y: 0, img: Trauma, type: "CONDITION" }
];

export const conditionTitle = {
  abfraction: "Abfraction",
  ankylosis: "Ankylosis",
  avulsion: "Avulsion",
  braces: "Braces",
  calculus: "Calculus",
  concussion: "Concussion",
  congenitallyMissing: "Congenitally Missing",
  discoloration: "Discoloration",
  driftDistal: "Drift Distal",
  driftMesial: "Drift Mesial",
  ectopicEruption: "Ectopic Eruption",
  fusedGerminatedTooth: "Fused / Germinated Tooth",
  fusion: "Fusion",
  gemination: "Gemination",
  hypersensitivity: "Hypersensitivity",
  hypoplasia: "Hypoplasia",
  impactedDistal: "Impacted Distal",
  impactedMesial: "Impacted Mesial",
  intrusion: "Intrusion",
  laceration: "Laceration",
  looseTooth: "Loose Tooth",
  openContactDistal: "Open Contact Distal",
  openContactMesial: "Open Contact Mesial",
  openMarginDistal: "Open Margin Distal",
  openMarginMesial: "Open Margin Mesial",
  partiallyErupted: "Partially Erupted",
  pegLateral: "Peg Lateral",
  pins: "Pins",
  poorMargIntegrity: "Poor Marg Integrity",
  recession: "Recession",
  spacer: "Spacer",
  splinted: "Splinted",
  squareDistal: "Square Distal",
  squareMesial: "Square Mesial",
  squareMiddle: "Square Middle",
  trauma: "Trauma"
};

// 
export const watch_notes_list = [
  { title: "Buccal", value: "Buccal" },
  { title: "Crown", value: "Crown" },
  { title: "Distal", value: "Distal" },
  { title: "Facial", value: "Facial" },
  { title: "Lingual", value: "Lingual" },
  { title: "Mesial", value: "Mesial" },
  { title: "Occlusal", value: "Occlusal" },
]
